import { render, staticRenderFns } from "./BsLightbox.vue?vue&type=template&id=11f08d48&"
import script from "./BsLightbox.vue?vue&type=script&lang=js&"
export * from "./BsLightbox.vue?vue&type=script&lang=js&"
import style0 from "./BsLightbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports